// src/theme/components.js

export const components = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: '18px', // 18px Buttons
        fontWeight: 600,
        textTransform: 'none',
        padding: '10px 24px',
        minHeight: '44px', // Touch target 44px
        transition: 'transform 0.15s ease-in-out, background-color 0.2s ease, box-shadow 0.2s ease',
        '&:active': {
          transform: 'scale(0.98)',
        },
        '&.Mui-focusVisible': {
          outline: '3px solid rgba(30, 58, 138, 0.4)',
          outlineOffset: '2px',
        },
      },
      containedPrimary: {
        boxShadow: '0 2px 4px rgba(30, 58, 138, 0.15)',
        '&:hover': {
          boxShadow: '0 4px 12px rgba(30, 58, 138, 0.25)',
        },
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: '20px', // 20px Cards
        border: '1px solid',
        transition: 'transform 0.2s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.2s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.2s ease',
        boxShadow: '0 4px 6px -1px rgba(15, 23, 42, 0.05), 0 10px 15px -3px rgba(15, 23, 42, 0.03)',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 10px 20px -3px rgba(15, 23, 42, 0.08), 0 4px 12px -2px rgba(15, 23, 42, 0.03)',
        },
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: '24px', // 24px Dialogs
        padding: '8px',
        boxShadow: '0px 25px 50px -12px rgba(0, 0, 0, 0.25)',
      },
      container: {
        backdropFilter: 'blur(8px)', // Blurs dialog backdrops
      },
    },
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        borderRadius: '16px', // 16px Inputs
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: '#E2E8F0', // Slate 200 default
          transition: 'border-color 0.15s ease-in-out, border-width 0.15s ease-in-out',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: '#94A3B8', // Slate 400 hover
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderWidth: '2px',
        },
      },
      input: {
        padding: '14px 16px',
        fontSize: '0.875rem',
      },
    },
  },
  MuiBadge: {
    styleOverrides: {
      badge: {
        borderRadius: '8px',
        fontSize: '0.75rem',
        fontWeight: 600,
        height: '20px',
        minWidth: '20px',
      },
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: {
        borderRadius: '12px',
        margin: '2px 8px',
        transition: 'background-color 0.15s ease',
      },
    },
  },
};
